var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classes},[_c('img',{staticClass:"mb-2 my-lg-1",class:_vm.className,attrs:{"src":_vm.getImgUrl(_vm.icon),"alt":""}}),_vm._t("upperText"),_vm._t("subText"),_vm._t("bttn")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }